import { Archive } from './icons/Archive'
import { ArrowLeft } from './icons/ArrowLeft'
import { ArrowRight } from './icons/ArrowRight'
import { Book } from './icons/Book'
import { Brain } from './icons/Brain'
import { Cmd } from './icons/Cmd'
import { Code } from './icons/Code'
import { Explore } from './icons/Explore'
import { Help } from './icons/Help'
import { History } from './icons/History'
import { Image } from './icons/Image'
import { Logout } from './icons/Logout'
import { Resources } from './icons/Resources'
import { Settings } from './icons/Settings'
import { Stats } from './icons/Stats'
import { Suitcase } from './icons/Suitcase'
import { User } from './icons/User'
import { Write } from './icons/Write'
import { Agents } from './icons/Agents'
import { ChevronRight } from './icons/ChevronRight'
import { ChevronLeft } from './icons/ChevronLeft'
import { ChevronDown } from './icons/ChevronDown'
import { ChevronUp } from './icons/ChevronUp'
import { Menu } from './icons/Menu'
import { Cross } from './icons/Cross'
import { Grid } from './icons/Grid'
import { Sidebar } from './icons/Sidebar'
import { Expand } from './icons/Expand'
import { Collapse } from './icons/Collapse'

export const iconMap = {
  archive: Archive,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  book: Book,
  brain: Brain,
  cmd: Cmd,
  code: Code,
  explore: Explore,
  help: Help,
  history: History,
  image: Image,
  logout: Logout,
  resources: Resources,
  settings: Settings,
  stats: Stats,
  suitcase: Suitcase,
  write: Write,
  agents: Agents,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  user: User,
  menu: Menu,
  cross: Cross,
  grid: Grid,
  sidebar: Sidebar,
  expand: Expand,
  collapse: Collapse,
} as const
